<div class="form-group">
    <label class="input-label">Short label in grid:</label>
    <input type="text"
           name="fieldOptions.label"
           value="{{fieldOptions.shortlabel}}"
           [(ngModel)]="fieldOptions.shortlabel"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
</div>